import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import styles from './SearchBar.scss.js';
import SearchIconLight from '../IconsDeprecated/SearchIconLight.js';
import ClearQueryIcon from '../IconsDeprecated/ClearQueryIcon.js';
import RecentSearches from './components/recent-searches/RecentSearches.js';
import Icon from '../../Icons/Icons/Icon/Icon.js';

const SearchBar = _ref => {
  let {
    onQuerySearch,
    onClearHistory = () => {},
    onDeleteRecentSearch = () => {},
    onClearQuery = () => {},
    placeholder = '',
    defaultQuery = '',
    recentSearches = [],
    dropdownTitle = 'RECENT SEARCHES',
    dropdownButtonText = 'Clear History',
    searchOnType = false,
    shouldClearOnEmptyInput = false,
    shouldShowSearchButton = false
  } = _ref;
  const [query, setQuery] = useState(defaultQuery);
  const inputElement = useRef(null);
  const handleSubmit = (value, blurElement) => {
    const queryTrimmed = value.trim();
    onQuerySearch(queryTrimmed);
    if (blurElement) {
      inputElement.current?.blur();
    }
  };
  const clearQuery = () => {
    onClearQuery();
    setQuery('');
  };
  const onQueryChange = event => {
    setQuery(event.target.value);
    const isQueryEmpty = !event.target.value.length;
    if (searchOnType) {
      handleSubmit(event.target.value, false);
      // When we clear the text, we want the same action that happens when the query is
      // cleared from the X button, depending on the shouldClearOnEmptyInput flag.
    } else if (isQueryEmpty && shouldClearOnEmptyInput) onClearQuery();
  };
  const onSelect = value => {
    setQuery(value);
    handleSubmit(value, true);
  };
  const handleKeyUp = event => {
    if (event.key === 'Enter') {
      handleSubmit(query, true);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, styles['search-bar-div'])
  }, !shouldShowSearchButton && /*#__PURE__*/React.createElement("span", {
    className: classNames(styles['search-icon'])
  }, /*#__PURE__*/React.createElement(SearchIconLight, null)), /*#__PURE__*/React.createElement("input", {
    ref: inputElement,
    value: query,
    type: "search",
    className: classNames(styles['input-search'], {
      [styles['input-search--extra-space']]: shouldShowSearchButton
    }),
    placeholder: placeholder,
    onChange: onQueryChange,
    onKeyUp: handleKeyUp
  }), !!recentSearches.length && /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['dropdown-wrapper'])
  }, /*#__PURE__*/React.createElement(RecentSearches, {
    recentSearches: recentSearches,
    onSelect: onSelect,
    onClearHistory: onClearHistory,
    onDeleteRecentSearch: onDeleteRecentSearch,
    dropdownTitle: dropdownTitle,
    dropdownButtonText: dropdownButtonText
  })), !!query && /*#__PURE__*/React.createElement("button", {
    className: classNames(styles['button-clear'], {
      [styles['button-clear--has-search-button']]: shouldShowSearchButton
    }),
    onClick: clearQuery
  }, /*#__PURE__*/React.createElement(ClearQueryIcon, null)), shouldShowSearchButton && /*#__PURE__*/React.createElement("button", {
    className: classNames(styles['button-search']),
    onClick: () => handleSubmit(query, true)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "search-neutral-xs-default"
  })));
};
var SearchBar$1 = SearchBar;

export { SearchBar$1 as default };
//# sourceMappingURL=SearchBar.js.map
